<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="header-account">
    <div class="buy-car" @click="toBuyCar">
      <span v-show="showNum">{{ cartNum }}</span>
    </div>
    <div class="account" v-if="!userName">
      <div class="account-left login" @click="login">登录</div>
      <div class="account-right" @click="sign">注册</div>
    </div>
    <div v-else class="account">
      <div class="account-left">
        <span>你好，</span>
        <div @mouseenter="hoverIn" @mouseleave="hoverOut" class="account-name">
          {{ userName }}
          <div class="accountSelect" v-show="showAccSelect">
            <ul>
              <li v-for="(item, index) in accountSelect" :key="index" @click="go(item.name)">
                <img :src="item.imgsrc" />
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <span>|</span>
      <div class="account-right" @click="quit">退出</div>
    </div>
  </div>
</template>

<script>
import apis from '@api/login'
import getNum from '@api/buyCar'
export default {
  name: 'Menus',
  data() {
    return {
      baseUrl: window.PROJECT_CONFIG.BASE_URL,
      cartNum: null, //购物车物品数量
      showNum: false, //是否显示购物车数量
      accountSelect: [
        {
          name: '我的书刊',
          url: '/list',
          imgsrc: require('@imgs/bookDark.png')
        },
        {
          name: '我的专辑',
          url: '/list',
          imgsrc: require('@imgs/albumDark.png')
        },
        {
          name: '数据分析',
          url: '/statistics/index.html#/?from=ebook',
          imgsrc: require('@imgs/statisticDark.png')
        }
      ],
      showAccSelect: false,
      baseUrl2: window.PROJECT_CONFIG.BASE_URL2
    }
  },
  computed: {
    userName() {
      return this.$store.state.common.userName
    }
  },
  mounted() {
    apis.login().then((res) => {
      if (res && res.data && res.status === 200) {
        let data = res.data
        if (data.code === 101) {
          localStorage.setItem('username', '')
          this.$store.commit('common/UPDATE_IS_LOGIN', false)
        } else {
          this.$store.commit('common/UPDATE_IS_SUB_ACCOUNT', data.data.isChild)
          this.$store.commit('common/UPDATE_USER_NAME', data.data.username)
          this.$store.commit('common/UPDATE_IS_LOGIN', true)
          localStorage.setItem('isChild', data.data.isChild)
          localStorage.setItem('username', data.data.username)
          this.getBuyCarNum()
        }
      }
    })
  },
  methods: {
    login() {
      this.$store.commit('manage/UPDATE_BOOKS_CURRENT_ACCOUNT', '')
      apis.login().then((res) => {
        if (res && res.data && res.status === 200) {
          console.log(res.data)
          let data = res.data
          if (data.code === 101) {
            // let url = window.location.href
            // window.location.href = data.data + '?service=' + url
            window.location.href = data.data
          } else {
            this.$store.commit('common/UPDATE_IS_SUB_ACCOUNT', data.data.isChild)
            this.$store.commit('common/UPDATE_USER_NAME', data.data.username)
            localStorage.setItem('isChild', data.data.isChild)
            localStorage.setItem('username', data.data.username)
          }
        }
      })
    },
    //注册方法
    sign() {
      // const url = window.location.href
      // window.location.href = this.baseUrl + '/fxsso/login?_scope=1&service=' + url
      window.location.href = this.baseUrl + '/fxsso/login?_scope=1'
    },
    //退出登录
    quit() {
      const url = window.location.href
      localStorage.setItem('userId', '')
      localStorage.setItem('token', '')
      // window.location.href = this.baseUrl + '/uuacLogout?_scope=1&service=' + url
      window.location.href = this.baseUrl + '/fxsso/logout?service=' + url
      localStorage.setItem('username', '')
      localStorage.setItem('isChild', '')
      this.$store.commit('manage/UPDATE_BOOKS_CURRENT_ACCOUNT', '')
    },
    toAccount() {
      // this.$router.push('/list')
    },
    toBuyCar() {
      let a = document.createElement('a')
      a.href = this.baseUrl + '/cart/cart.jhtml'
      a.click()
    },
    // 获取购物车数量
    getBuyCarNum() {
      let params = {
        loginName: this.userName
      }
      getNum.getNum(params).then((res) => {
        if (res.data.code) {
          this.cartNum = res.data.code
          this.showNum = true
        } else {
          this.showNum = false
        }
      })
    },
    hoverIn() {
      this.showAccSelect = true
    },
    hoverOut() {
      this.showAccSelect = false
    },
    go(name) {
      this.showAccSelect = false
      switch (name) {
        case '我的书刊':
          this.$store.commit('manage/UPDATE_SIDEBAR_SUBINDEX', '0')
          this.$router.push({ name: 'list', params: { to: 'book' } })
          this.$store.commit('manage/UPDATE_CURRENT_MANAGE', 'MyBooks')
          break
        case '我的专辑':
          this.$router.push('/list')
          this.$store.commit('manage/UPDATE_CURRENT_MANAGE', 'MyBookshelf')
          this.$store.commit('manage/UPDATE_SIDEBAR_SUBINDEX', '1')
          break
        case '数据分析':
          window.location.href = this.baseUrl2 + '/statistics/index.html#/?from=ebook'
          break
      }
    }
  }
}
</script>

<style lang="scss">
.header-account {
  display: flex;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  .buy-car {
    width: 18px;
    height: 16px;
    margin-right: 15px;
    background-image: url('../../../assets/imgs/buy-car.png');
    background-size: 100% 100%;
    margin-bottom: 4px;
    &:hover {
      background-image: url('../../../assets/imgs/buy-car-active.png');
    }
    span {
      color: #fff;
      background: #df5813;
      display: inline-block;
      width: 20px;
      height: 20px;
      border-radius: 20px;
      text-align: center;
      line-height: 20px;
      position: relative;
      left: 8px;
      top: -6px;
      font-size: 14px;
    }
  }
  .account {
    white-space: nowrap;
    .account-left,
    .account-right {
      display: inline-block;
    }
    .account-left {
      span {
        padding-left: 0;
      }
      .account-name {
        position: relative;
        display: inline-block;
      }
      .accountSelect {
        // width: 100%;
        width: 120px;
        height: 120px;
        position: absolute;
        left: 50%;
        top: 15px;
        transform: translateX(-50%);
        // padding: 10px 0;
        ul {
          width: 100%;
          // width: 200px;
          list-style: none;
          height: auto;
          background: #fff;
          border-radius: 10px;
          border: 2px solid #eee;
          li {
            height: 40px;
            line-height: 36px;
            text-align: center;
            width: 100%;
            &:hover {
              color: #df5813;
            }
            img {
              height: 13px;
              vertical-align: middle;
              margin-right: 3px;
            }
          }
        }
      }
    }
    .account-right {
      margin-left: 10px;
    }
    span {
      padding-left: 10px;
    }
  }
  .login {
    width: 60px;
    height: 28px;
    background-color: #fff;
    color: #df5813;
    border: 1px solid #df5813;
    line-height: 28px;
    text-align: center;
    margin-left: 10px;
    &:hover {
      background-color: #df5813;
      color: #fff;
    }
  }
  .account-right {
    &:hover {
      color: #df5813;
    }
  }
}
</style>
